import { Component, OnInit } from '@angular/core';
import { NavigationService } from '../../services/navigation.service';
import { RegistrationService } from '../../services/registration.service';
import { ListManagerService } from '../../services/list-manager.service';
import { EnrollmentService } from '../../services/enrollment.service';
import * as _ from 'lodash';
import { PhoneService } from 'src/app/services/phone.service';
import { VariablesService } from '../../services/variables.service';

@Component({
  templateUrl: './attendee.component.html'
})
export class AttendeeComponent implements OnInit {
  isSubmitting = false;
  isError = false;
  attendee;
  prefixList;
  suffixList;
  workPhone;
  homePhone;
  mobilePhone;
  workAddress;
  homeAddress;
  emailAddress;
  adminContact;
  adminPhone;
  emerContact;
  emerContactMainPhone;
  emerContactAltPhone;
  DisabilityType;
  mealList;
  personalConsiderationsList;
  $mtcverifyEmailAddress;
  $mtcMailToAddress;
  isRegComplete;
  enrollment;
  answer;
  isFormCompleted = false;
  langinterp;
  nuerdiv;
  wealthManFirm;
  wealthFirms;
  wealthManFirmQualityLevel;
  wealthFirmQualLevels;
  boardCouncil;
  councils;
  cfp;
  cfpNumber;
  fieldManager;
  osjName;
  repIdNum;
  foodAllergies = [];
  foodAllergiesList;
  clickedCountry;
  allergiesString = "";
  triedSubmit = false;
  donation;
  benefitNights;
  department;
  childEventClicked(data) {
    this.clickedCountry = data;
  }


  constructor(
    private navigationService: NavigationService,
    private registrationService: RegistrationService,
    private listService: ListManagerService,
    private enrollmentService: EnrollmentService,
    private phoneService: PhoneService,
    private variablesService: VariablesService
  ) {

    this.enrollment = this.registrationService.getEnrollment({});
    this.isRegComplete = this.registrationService.isRegistrationComplete();
    /* this.enrollment.HotelNeeded = "false"; */

    this.attendee = this.registrationService.getAttendee({});
    this.workPhone = this.registrationService.getPhone(this.attendee, "WORK", {});
    this.homePhone = this.registrationService.getPhone(this.attendee, "HOME", {});
    this.mobilePhone = this.registrationService.getPhone(this.attendee, "MOBILE", {});
    this.workAddress = this.registrationService.getAddress(this.attendee, "WORK", {});
    this.homeAddress = this.registrationService.getAddress(this.attendee, "HOME", {});
    this.emailAddress = this.registrationService.getEmail(this.attendee, "BUSINESS", {});
    this.langinterp = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.LANGUAGE_INTERPRETER.ID,
      {}
    );
    this.nuerdiv = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.NUERODIVERSITY_CONSIDERATIONA.ID,
      {}
    );
    this.wealthManFirm = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.WEALTH_MANAGEMENT_FIRM.ID,
      {}
    );
    this.wealthManFirmQualityLevel = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.WEALTH_MANAGEMENT_FIRM_QUALIFICATION_LEVEL.ID,
      {}
    );
    this.boardCouncil = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.ADVISE_BOARD_COUNCIL.ID,
      {}
    );
    this.cfp = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.CFP.ID,
      {}
    );
    this.cfpNumber = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.CFP_NUMBER.ID,
      {}
    );
    this.fieldManager = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.FIELD_MANAGER.ID,
      {}
    );
    this.osjName = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.OSJ.ID,
      {}
    );
    this.repIdNum = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.REPID.ID,
      {}
    );
    this.donation = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.OSAIC_DONATION.ID,
      {}
    );
    this.benefitNights = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.HOTEL_BENEFIT_NIGHTS.ID,
      {}
    );
    this.department = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.DEPARTMENT_NAME.ID,
      {}
    );
    this.adminContact = this.registrationService.getAdminContact({});
    this.adminPhone = this.adminContact.AdminContactPhone[0];
    this.emerContactMainPhone = this.registrationService.getEmergencyContactPhone(this.attendee, "DTPHONE", {});
    this.emerContactAltPhone = this.registrationService.getEmergencyContactPhone(this.attendee, "ALTPHONE", {});
    this.DisabilityType = this.registrationService.getDisabilities(this.attendee, "");
    if (this.workAddress.CountryISOCode === "" || this.workAddress.CountryISOCode === " " || this.workAddress.CountryISOCode === undefined) {
      this.workAddress.CountryISOCode = "US";
    }

    if (this.homeAddress.CountryISOCode === "" || this.homeAddress.CountryISOCode === " " || this.homeAddress.CountryISOCode === undefined) {
      this.homeAddress.CountryISOCode = "US";
    }
    this.wealthFirms = [
      { code: "Osaic Wealth", name: "Osaic Wealth" },
      { code: "Osaic Institutions", name: "Osaic Institutions" },
      { code: "American Portfolios", name: "American Portfolios" },
      { code: "Lincoln Financial Advisors", name: "Lincoln Financial Advisors" },
      { code: "Lincoln Financial Network", name: "Lincoln Financial Network" },
      { code: "Triad", name: "Triad" },
    ];
    
    this.wealthFirmQualLevels = [
      { code: "AP Ascend", name: "AP Ascend", nights: "0"},
      { code: "FSC Masters Club", name: "FSC Masters Club", nights: "3" },
      { code: "FSC President's Club", name: "FSC President's Club", nights: "3" },
      { code: "FSC Achievers Club", name: "FSC Achievers Club", nights: "2" },
      { code: "IFG Elite Advisor", name: "IFG Elite Advisor", nights: "0" },
      { code: "LFG Cabinet", name: "LFG Cabinet", nights: "3" },
      { code: "LFG Council", name: "LFG Council", nights: "3" },
      { code: "LFG TRG", name: "LFG TRG", nights: "3" },
      { code: "RAA Royal Court", name: "RAA Royal Court", nights: "3" },
      { code: "RAA Royal Council", name: "RAA Royal Council", nights: "3" },
      { code: "SPF Champions Circle", name: "SPF Champions Circle", nights: "3" },
      { code: "SPF Leaders Council", name: "SPF Leaders Council", nights: "3" },
      { code: "SPF Honors Council", name: "SPF Honors Council", nights: "3" },
      { code: "SPF Lifetime Achiever", name: "SPF Lifetime Achiever", nights: "3" },
      { code: "SPF Achievers Council", name: "SPF Achievers Council", nights: "2" },
      { code: "SAI Pinnacle Club", name: "SAI Pinnacle Club", nights: "0" },
      { code: "SAI Excellence Club", name: "SAI Excellence Club", nights: "0" },
      { code: "SAI Achievement Club", name: "SAI Achievement Club", nights: "3" },
      { code: "TRI Chairman's Club", name: "TRI Chairman's Club", nights: "3" },
      { code: "WFS Crystal Eagle", name: "WFS Crystal Eagle", nights: "3" },
      { code: "WFS Platinum Eagle", name: "WFS Platinum Eagle", nights: "3" },
      { code: "WFS Gold Eagle", name: "WFS Gold Eagle", nights: "3" },
      { code: "WFS Silver Eagle", name: "WFS Silver Eagle", nights: "2" },
      { code: "WFS Bronze Eagle", name: "WFS Bronze Eagle", nights: "0" },
      
      
    ]

    this.councils = [
      { code: "Fee Centric Advisory Solutions Council", name: "Fee Centric Advisory Solutions Council"},
      { code: "National Advisory Board", name: "National Advisory Board" },
      { code: "National Operational Excellence Council", name: "National Operational Excellence Council" },
      { code: "NextGen Council", name: "NextGen Council" },
      { code: "Teams Council", name: "Teams Council" },
      { code: "Women’s Advisory Board", name: "Women’s Advisory Board" },
    ];

    this.foodAllergiesList = [
      { code: "Dairy", name: "Dairy" },
      { code: "Eggs", name: "Eggs" },
      { code: "Peanuts", name: "Peanuts" },
      { code: "Tree Nuts", name: "Tree Nuts (almonds/cashews/walnuts)" },
      { code: "Fish", name: "Fish (bass/cod/flounder)" },
      { code: "Shellfish", name: "Shellfish (crab/lobster/shrimp)" },
      { code: "Soy", name: "Soy" },
      { code: "Wheat", name: "Wheat" },
      { code: "Other", name: "Other" }
    ];
    
    if(!this.attendee.$mtcAllergens) {
      this.attendee.$mtcAllergens = [];
    }


    if (this.attendee.ResidenceCountryISOCode && this.workAddress.CountryISOCode) {
      if (this.attendee.ResidenceCountryISOCode == this.workAddress.CountryISOCode) {
        this.attendee.$mtcvarCountryOfRes = 'Yes';
      } else {
        this.attendee.$mtcvarCountryOfRes = 'No';
      }
    }

    this.listService.getCommonPrefixList().then(list => {
      this.prefixList = list;
    });
    this.listService.getSuffixList().then(list => {
      this.suffixList = list;
    });
    this.listService.getMealPreferenceList().then(list => {
      this.mealList = list;
    });
    this.listService.getDisabilityList().then(list => {
      this.personalConsiderationsList = list;
      this.personalConsiderationsList.forEach(disability => {
        console.log(disability)
        if(disability.name == "Hearing Impaired"){
          disability.name = "Deaf/Hard of Hearing"
        }
        
      });
    });
    
    this.mtcMailToAddress = "WORK";

    this.detectMailTo();
    this.setMailTo();

  }

  ngOnInit(): void { }

  includes(arr, val) {
    return _.includes(arr, val);
  }

  considerationUpdate(consideration) {
    let justadded = false;

    if (!_.includes(this.attendee.DisabilityType, consideration.code)) {
      this.attendee.DisabilityType.push(consideration.code);
      justadded = true;
    }
    if (justadded === false && _.includes(this.attendee.DisabilityType, consideration.code)) {
      var index = this.attendee.DisabilityType.indexOf(consideration.code);
      if (index !== -1) {
        this.attendee.DisabilityType.splice(index, 1);
      }
    }
  }

  allergyUpdate(allergy){
    let justadded = false;

    if (!_.includes(this.attendee.$mtcAllergens, allergy.code)) {
      this.attendee.$mtcAllergens.push(allergy.code);
      justadded = true;
    }
    if (justadded === false && _.includes(this.attendee.$mtcAllergens, allergy.code)) {
      var index = this.attendee.$mtcAllergens.indexOf(allergy.code);
      if (index !== -1) {
        this.attendee.$mtcAllergens.splice(index, 1);
      }
    }
  }

  FieldsChange(values: any) {
    if (values.checked) {
      this.homeAddress.AddressLine1 = this.workAddress.AddressLine1;
      this.homeAddress.AddressLine2 = this.workAddress.AddressLine2;
      this.homeAddress.Zip = this.workAddress.Zip;
      this.homeAddress.City = this.workAddress.City;
      this.homeAddress.StateProvince = this.workAddress.StateProvince;
      this.homeAddress.CountryISOCode = this.workAddress.CountryISOCode;
    } else {
      this.homeAddress.AddressLine1 = "";
      this.homeAddress.AddressLine2 = "";
      this.homeAddress.Zip = "";
      this.homeAddress.City = "";
      this.homeAddress.StateProvince = "";
      this.homeAddress.CountryISOCode = "";
    }
  }
  cleanAdminContact() {
    if (!this.enrollment.$mtcHasAdminContact) {
      this.adminContact.AdminContactName = undefined;
      this.adminContact.AdminContactEmailAddress = undefined;
      this.adminContact.AdminContactPhone = undefined;
    }
  }
  cleanConsiderations() {
    if (!(this.attendee.DietaryNeed === "FOODALLE") && !(this.attendee.DietaryNeed === "OTHER")) {
      this.attendee.DietaryConsiderations = undefined;
    }
    if (this.attendee.DisabilityType) {

      if (!_.includes(this.attendee.DisabilityType, 'OTHER')) {
        this.attendee.PersonalConsiderations = undefined;
      }
    }
    // if (!this.attendee.$mtcHasConsiderations) {
    //     this.attendee.DietaryNeed = undefined;
    //     this.attendee.DietaryConsiderations = undefined;
    //     this.attendee.DisabilityType = undefined;
    //     this.attendee.PersonalConsiderations = undefined;
    // } else if (this.attendee.DietaryNeed === undefined && this.attendee.DisabilityType.length === 0) {
    //   this.attendee.$mtcHasConsiderations = false;
    // }
  }

  mtcMailToAddress;

  detectMailTo() {
    if (this.attendee) {
      this.attendee.Address.forEach(add => {
        if (add.MailTo) {
          this.mtcMailToAddress = add.AddressType;
        }
      });
    }

  }

  setMailTo() {
    if (this.attendee) {
      this.attendee.Address.forEach(add => {
        if (add.AddressType === this.mtcMailToAddress) {
          add.MailTo = true;
        } else {
          add.MailTo = false;
        }
      });
    }
    this.phoneService.triggeredChange();
  }

  setBenefitNights(value){
    for (let index = 0; index < this.wealthFirmQualLevels.length; index++) {      
       if(this.wealthFirmQualLevels[index].code == value){
         console.log(this.wealthFirmQualLevels[index].nights)
         this.benefitNights.Value = this.wealthFirmQualLevels[index].nights;
       }
    }
      
    

  }


  forward(form) {
    this.isSubmitting = true;
    this.isFormCompleted = true;
    this.triedSubmit = true;
    console.log(form);
    if (form.valid) {
      this.cleanAdminContact();
      //this.cleanConsiderations();      
      this.navigationService.forward();
    } else {
      this.isError = true;
      this.isSubmitting = false;

    }
  }

  back() {
    this.navigationService.back();
  }
}
